
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import './IconButton.css'

// Types of icons. These are used to position the background.
const types = [
  'archive',
  'connection',
  'delete',
  'edit',
  'debugger',
  'star',
  'install',
  'approve',
  'pending',
  'more',
  'remove',
  'add'
]

class IconButton extends Component {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    const index = types.indexOf(this.props.type)
    const active = this.state.active || false

    // Should probably be props validation
    if (index < 0) throw new Error('Invalid button type')

    const style = {
      backgroundPosition: `${active ? -20 : 0}px ${index * -20}px`
    }

    const classes = classnames({
      'ui-IconButton': true,
      [this.props.type]: true
    })

    return (
      <span
        style={style}
        className={classes}
        hidden={this.props.hidden === true}
        onClick={this.props.onClick}
        onMouseOver={this.onMouseOver.bind(this)}
        onMouseOut={this.onMouseOut.bind(this)} />
    )
  }

  onMouseOver () {
    this.setState({ active: true })
  }

  onMouseOut () {
    this.setState({ active: false })
  }
}

IconButton.propTypes = {
  hidden: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
}

IconButton.displayName = 'IconButton'

export default IconButton



// WEBPACK FOOTER //
// ./ui/IconButton.js